export var EnName;
(function (EnName) {
    EnName["firstName"] = "firstName";
    EnName["lastName"] = "lastName";
})(EnName || (EnName = {}));
export const NameField = { ...EnName };
export var BaseNonNamePassengerField;
(function (BaseNonNamePassengerField) {
    BaseNonNamePassengerField["birthday"] = "birthday";
})(BaseNonNamePassengerField || (BaseNonNamePassengerField = {}));
var ExtraField;
(function (ExtraField) {
    ExtraField["phoneBody"] = "phoneBody";
})(ExtraField || (ExtraField = {}));
export var AgreementFields;
(function (AgreementFields) {
    AgreementFields["hasAgreePersonalData"] = "hasAgreePersonalData";
})(AgreementFields || (AgreementFields = {}));
export const PassengerField = { ...BaseNonNamePassengerField, ...EnName };
export const InsurerField = {
    ...NameField,
    ...BaseNonNamePassengerField,
    ...ExtraField,
};
